import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type Store from '@ember-data/store';
import type AbilitiesService from 'ember-can/services/abilities';
import type { PaginatedRecordArray } from 'garaje/infinity-models/v3-offset';
import type Company from 'garaje/models/company';
import type GlobalFlow from 'garaje/models/global-flow';
import type Questionnaire from 'garaje/models/questionnaire';
import type StateService from 'garaje/services/state';

import type { LocationOverviewSignInFlowsShowRouteModel } from '../route';

interface FlowQuestionnairesRouteModel {
  company: Company;
  flow: GlobalFlow;
  questionnaireCount: number;
}

export default class FlowQuestionnairesRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare router: RouterService;
  @service declare state: StateService;
  @service declare store: Store;

  beforeModel(): void {
    const { globalFlow: flow } = <LocationOverviewSignInFlowsShowRouteModel>(
      this.modelFor('location-overview.sign-in-flows.show')
    );

    if (this.abilities.cannot('navigate to global questionnaires')) {
      this.router.replaceWith('location-overview.sign-in-flows.show.index', flow.id);
    }
  }

  async model(): Promise<FlowQuestionnairesRouteModel> {
    const { globalFlow: flow } = <LocationOverviewSignInFlowsShowRouteModel>(
      this.modelFor('location-overview.sign-in-flows.show')
    );
    const company = this.state.currentCompany;

    const result = <PaginatedRecordArray<Questionnaire>>await this.store.query('questionnaire', {
      filter: {
        company: company.id,
      },
      page: {
        limit: 1,
        offset: 0,
      },
    });
    const { meta } = <{ meta: { total: number } }>(result as unknown);

    return { flow, company, questionnaireCount: meta.total };
  }
}
